<template>
  <div>

    <div v-for="(item,index) in this.datas.Items" :key="index">
      <div class="form-inline">
        <h2 v-if="!isSettingEnable" >{{item.Text}}</h2>
        <input v-if="isSettingEnable" type="text" class="form-control"  placeholder="" v-model="item.Text">
        <a class="btn btn-danger dbutton" @click="DataItemMaster_Remove(item)" v-show="isSettingEnable"><i class="fa fa-trash-alt"></i></a>
        <a class="btn btn-primary dbutton" @click="DataItemMaster_MoveUp(item)" v-show="isSettingEnable"><i class="fa fa-angle-up"></i> </a>
        <a class="btn btn-primary dbutton" @click="DataItemMaster_MoveDown(item)" v-show="isSettingEnable"><i class="fa fa-angle-down"></i>  </a>

      </div>


      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" v-for="(subItem,index) in item.SubItems" :key="index">
          <a v-if="!isSettingEnable" role="button" class="btn btn-info abutton" :style="'background-color:'+bgColor" @click="gotoMenu(subItem)">{{subItem.Text}}</a>
          <input v-if="isSettingEnable" type="text" class="form-control"  placeholder="" v-model="subItem.Text">
          <a class="btn btn-danger dbutton" @click="DataItemDetail_Remove(item,subItem)" v-show="isSettingEnable"><i class="fa fa-trash-alt"></i></a>
          <a class="btn btn-primary dbutton" @click="DataItemDetail_MoveUp(item.SubItems,subItem)" v-show="isSettingEnable"><i class="fa fa-angle-left"></i> </a>
          <a class="btn btn-primary dbutton" @click="DataItemDetail_MoveDown(item.SubItems,subItem)" v-show="isSettingEnable"><i class="fa fa-angle-right"></i>  </a>
          <a class="btn btn-primary dbutton" @click="DataItemDetail_Setting(item.SubItems,subItem)" v-show="isSettingEnable"><i class="fa fa-cog"></i>  </a>
        </div>
        <div class="col-3">
          <a class="btn btn-primary dbutton " style="" @click="DataItemDetail_AddLast(item.SubItems)" v-show="isSettingEnable"><i class="fa fa-plus-circle"></i></a>
        </div>

      </div>


      <hr>
    </div>
    <a class="btn btn-primary dbutton " style="" @click="DataItemMaster_AddLast()" v-show="isSettingEnable"><i class="fa fa-plus-circle"></i></a>

    <DLGMenuEdit ref="dlgMenuEdit"></DLGMenuEdit>
  </div>
</template>

<script>
/**

 **/
import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import DLGMenuEdit from "../DLGMenuEdit";

export default {
  components: {DLGMenuEdit},
  //name: "conentCatalog",
  props: ["datas","isSettingEnable", "bgColor"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      Menu1: {
        Items: [
          {
            SystemId: "建成扶輪社",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "關於建成",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "年度營運",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "家族扶輪社",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "金蘭扶輪社",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "仙台扶輪社",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "名古屋扶輪社",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "3482地區",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "關於3482",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "國際扶輪",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "關於國際扶輪",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "扶輪社中央系",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "學習中心",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "品牌中心",
                LayoutType: "",
              },
            ]
          },
        ],
      },
      Menu2: {
        Items: [
          {
            SystemId: "社會服務",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "每週例會",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "例會演講資料",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "高爾夫球隊",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "登山隊",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "重訓保健隊",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "內輪會",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "就職典禮",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "中秋晚會",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "年終晚會",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "授證典禮",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "金蘭社聯誼",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "社區服務",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "台文獎學金",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "大內高手贊助",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "好心肝贊助",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "社區服務集錦",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "國際服務",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "名古屋扶輪社",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "仙台扶輪社",
                LayoutType: "",
              },
              {
                SystemId: "",
                OrderKey: "",
                Text: "扶輪基金專案",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "職業服務",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "職業服務",
                LayoutType: "",
              },
            ]
          },
          {
            SystemId: "青少年服務",
            OrderKey: "",
            Text: "",
            SubItems: [
              {
                SystemId: "",
                OrderKey: "",
                Text: "青少年服務",
                LayoutType: "",
              },
            ]
          },
        ]
      },
      webContent:{
        Menu:{
          Items:[
            {
              SystemId:"",
              OrderKey:"",
              Text:"",
              SubItems:[
                {
                  SystemId:"",
                  OrderKey:"",
                  Text:"",
                  LayoutType:"",
                },
              ]
            }
          ]
        },
        layoutA:{
          HtmlContent01:"",
          HtmlContent02:"",
          HtmlContent03:"",
          Items:[
            {
              SystemId:"",
              Date:"",
              Desc:"",
              Memo:"",
              HtmlContent01:"",
              HtmlContent02:"",
              HtmlContent03:"",
              CloudDownloadUrl:"",
              Images:[
                {
                  SystemId:"",
                  Url:"",
                  OrderKey:"",
                  Desc:"",
                }
              ],
              Videos:[
                {
                  SystemId:"",
                  Url:"",
                  OrderKey:"",
                  Desc:"",
                }
              ],
              AttachFiles:[
                {
                  SystemId:"",
                  Url:"",
                  OrderKey:"",
                  Desc:"",
                }
              ]
            }
          ]
        },
        IndexPage:[
          {
            SystemId:"",
            OrderKey:"",
            Text:"",
            Images:[
              {
                SystemId:"",
                Url:"",
                OrderKey:"",
                Desc:"",
              }
            ],
            TextLists:[
              {
                SystemId:"",
                OrderKey:"",
                IsEnable:"",
                Date:"",
                Desc:"",
              }
            ],
            Videos:[
              {
                SystemId:"",
                Url:"",
                OrderKey:"",
                Desc:"",
              }
            ],
            AttachFiles:[
              {
                SystemId:"",
                Url:"",
                OrderKey:"",
                Desc:"",
              }
            ]
          }
        ],
        YearsPage:{

        }
      }
    };
  },
  methods: {
    gotoMenu(item){
      this.$router.push({ name: 'ContentEdit', query: { SystemId: item.SystemId }})
    },
    execSetting(){
      this.isSettingEnable=!this.isSettingEnable;
    },
    DataItemMaster_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.datas.Items,"SystemId","OrderKey")
    },
    DataItemMaster_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.datas.Items,"SystemId","OrderKey")
    },
    DataItemMaster_AddLast(){
      let newItem=
          {
            SystemId:"",
            OrderKey:"",
            Text:"",
            RedirectEnable:false,
            RedirectUrl:"",
            RedirectUrlTarget:"",
            SubItems:[
            ]
          }
      newItem.SystemId=util.uuid();

      arrayUtil.orderAppendLast(newItem,this.datas.Items,"OrderKey")
    },
    DataItemMaster_Remove(item){
      arrayUtil.removeByPredicate(this.datas.Items,s => s.SystemId===item.SystemId);
    },
    //----------------------
    DataItemDetail_MoveUp(parent,item){
      arrayUtil.orderMove(false,item.SystemId,parent,"SystemId","OrderKey")
    },
    DataItemDetail_MoveDown(parent,item){
      arrayUtil.orderMove(true,item.SystemId,parent,"SystemId","OrderKey")
    },
    DataItemDetail_AddLast(parent){
      let newItem={
            SystemId:"",
            OrderKey:"",
            Text:"",
            LayoutType:"",
            RedirectEnable:false,
            RedirectUrl:"",
            RedirectUrlTarget:"",
          }
      newItem.SystemId=util.uuid();

      arrayUtil.orderAppendLast(newItem,parent,"OrderKey")
    },
    DataItemDetail_Remove(parent,item){
      arrayUtil.removeByPredicate(parent.SubItems,s => s.SystemId===item.SystemId);
    },
    DataItemDetail_Setting(parent,item){
        this.$refs.dlgMenuEdit.menu=item;
        this.$refs.dlgMenuEdit.showModal();
    },
    btnTest(){

      let data = {
        data:"testV"
      };

      apiAdmin.api_Upload(data).then((data)=>{
        console.log(data);
      });
      // apiAdmin.api_Test(data).then((data)=>{
      //   debugger // eslint-disable-line
      //   console.log(data);
      // });
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.abutton{
  color: white;
  width: 100%;
  margin-bottom: 10px;
}
.cbutton{
  background-color: #1b9e3e;
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}

.dbutton{
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}
.topButton{
  background-color: #2bac56;
}
.leftButton{
  background-color: #6cb2eb;
}
</style>
